// extracted by mini-css-extract-plugin
export default {"language":"LanguageSkillTag_language__400lo","languageLevel":"LanguageSkillTag_languageLevel__j982E","languageDescription":"LanguageSkillTag_languageDescription__yjeS-"};